import { render, staticRenderFns } from "./Instalments.vue?vue&type=template&id=e809c2bc"
import script from "./Instalments.vue?vue&type=script&lang=js"
export * from "./Instalments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports